import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MotionLink = motion.create(Link);

export default function CallToActionSection() {
  return (
    <section className="py-20 px-4 bg-gradient-to-b from-orange-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-orange-600 to-orange-500 dark:from-orange-700 dark:to-orange-600 rounded-3xl p-8 md:p-12 text-center text-white shadow-xl"
        >
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-3xl md:text-4xl font-bold mb-4"
          >
            Ready to see what your neighbors are giving away?
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="text-lg md:text-xl text-orange-100 dark:text-orange-200 mb-8 max-w-2xl mx-auto"
          >
            It's free to post, browse, and discover — just bring a little kindness.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <MotionLink
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              to="/signup"
              className="px-8 py-4 rounded-xl bg-white dark:bg-gray-800 text-orange-600 dark:text-orange-400 font-semibold shadow-lg hover:shadow-xl transition-all text-center text-lg"
            >
              Get Started Free
            </MotionLink>
            <MotionLink
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              to="/listings"
              className="px-8 py-4 rounded-xl border-2 border-white text-white font-semibold hover:bg-white/10 transition-all text-center text-lg"
            >
              Browse Listings
            </MotionLink>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
            className="mt-8 text-orange-100 dark:text-orange-200"
          >
            <p className="text-sm">
              No credit card required • Free forever • Cancel anytime
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
} 